export const defaultUpdateValues = {
  issued_at: "",
  po_number: "",
  comment: "",
};
